module.exports = __webpack_public_path__ + "4e5558937ac9b617319bce9cdad283f1.pdf";